/**
 * @author piotrzurek
 * @since 2021-12-29
 */

import { Field, FieldProps } from "formik";
import * as React from "react";

import { Checkbox } from "@ui/Atoms/Form";
import { TestWrapper } from "@ui/Atoms/TestWrapper";
import { FormikInputWithError } from "@ui/Molecules/FormikInputWithError";

interface Props {
  testId?: string;
  labelTestId?: string;
  checkboxTestId?: string;
  errorTestId?: string;
  name: string;
  id: string;
  label: string | React.ReactElement;
  className?: string;
  onChange?: (e: React.SyntheticEvent) => void;
}

const TermsField = (props: Props): React.ReactElement => (
  <TestWrapper testId={props.testId}>
    <div className={props.className}>
      <Field>
        {({ form }: FieldProps) => (
          <React.Fragment>
            <Checkbox
              labelTestId={props.labelTestId}
              testId={props.checkboxTestId}
              label={props.label}
              name={props.name}
              id={props.id}
              onChange={event => {
                form.setFieldTouched(props.name, true);
                form.handleChange(event);
                props.onChange?.(event);
              }}
              checked={form.values[props.name]}
            />

            {/* Display error */}
            <FormikInputWithError
              isHidden
              name={props.name}
              handleChange={() => null}
              errorTestId={props.errorTestId}
            />
          </React.Fragment>
        )}
      </Field>
    </div>
  </TestWrapper>
);

export { TermsField };
